export const linksConstants = {
  INIT: 'LINKS_INIT',
  SUCCESS: 'LINKS_SUCCESS',
  ADD: 'LINKS_ADD',
  UPDATE: 'LINKS_UPDATE',
  FAILURE: 'LINKS_FAILURE',
  REMOVE: 'LINKS_REMOVE',
  CLEAR: 'LINKS_CLEAR',
}
